// Controlled docType vocabulary — mirror of backend/utils/doc-type-profiles.ts
// on the server (the frontend build cannot import server sources). Keep in sync.
//
// AUTO-GENERATED by `pnpm run sync:doc-types`. Do not edit manually.
// To add a new docType: edit backend/utils/doc-type-profiles.ts, then run
// `pnpm run sync:doc-types` to regenerate this file.

export const DOC_TYPES = [
  'transcript',
  'minutes',
  'spec',
  'user-story',
  'contract',
  'api-doc',
  'code-summary',
  'design',
  'plan',
  'test',
  'textbook',
  'reference',
  'status',
  'other',
] as const

export type DocType = (typeof DOC_TYPES)[number]

export function toDocTypes(values: readonly string[]): DocType[] {
  return values.filter((value): value is DocType =>
    (DOC_TYPES as readonly string[]).includes(value)
  )
}

export const DOC_TYPE_LABELS: Record<DocType, string> = {
  transcript: 'Transcript',
  minutes: 'Meeting Minutes',
  spec: 'Specification',
  'user-story': 'User Story',
  contract: 'Contract',
  'api-doc': 'API Documentation',
  'code-summary': 'Code Summary',
  design: 'Design',
  plan: 'Plan',
  test: 'Test Document',
  textbook: 'Textbook',
  reference: 'Reference',
  status: 'Status Report',
  other: 'Other',
}

export const DOC_TYPE_HINTS: Partial<Record<DocType, string>> = {
  spec: 'What it must do — requirements, acceptance criteria, SHALL/ MUST statements',
  design: "How we'll build it — architecture, component diagrams, implementation approach",
  transcript: 'Decisions and action items extracted automatically',
  contract: 'Defined terms extracted for precise search',
  status: 'Time-decay applied — recent reports rank higher',
  textbook: 'Page-based chunking for large PDF textbooks (disable with TEXTBOOK_PIPELINE_ENABLED=0)',
}

export const MAX_TAGS_PER_FILE = 10
const MAX_TAG_LENGTH = 32

/**
 * Mirror of the server's tag normalization (backend/utils/tag-normalize.ts):
 * trim, lowercase, whitespace->hyphens, strip non [a-z0-9-], collapse/trim
 * hyphens. Returns null when nothing valid remains or too long.
 */
export function normalizeTag(raw: string): string | null {
  const normalized = raw
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '')
  if (normalized.length === 0 || normalized.length > MAX_TAG_LENGTH) return null
  return normalized
}
